var exports = {
  "HU": "xe7b6e3d6--831184--aside",
  "qf": "xe7b6e3d6--831184--sticky",
  "DW": "xe7b6e3d6--831184--sticky-top-space",
};

module.exports = exports;
